"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecognitionRequest = void 0;
var RecognitionRequest = /** @class */ (function () {
    function RecognitionRequest() {
    }
    return RecognitionRequest;
}());
exports.RecognitionRequest = RecognitionRequest;
;
//# sourceMappingURL=recognition.request.js.map